import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'validate',
  standalone: true
})
export class ValidatePipe implements PipeTransform {

  // transform(value: unknown, ...args: unknown[]): unknown {
  //   return null;
  // }
  transform(value: string): string {
    if (!value) return '';

    // Handle snake_case and camelCase, and add special cases
    return value
      .replace(/_/g, ' ') // Replace underscores with spaces
      .replace(/([A-Z])/g, ' $1') // Add space before uppercase letters
      .toLowerCase() // Convert everything to lowercase first
      .replace(/\btxn\b/g, 'Transaction') // Replace "txn" with "Transaction"
      .replace(/\bId\b/g, 'ID') // Replace "Id" with "ID"
      .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
      .trim();
  }

}
